export type TimeUnit = "HOUR" | "DAY" | "MONTH" | "YEAR";

export function formatPercent(value?: number): string {
  if (value === undefined) {
    return "-";
  }
  const formated = Number(value).toLocaleString("EN", {
    maximumFractionDigits: 2,
  });
  return `${formated}%`;
}

export function formatNumber(value?: number, digits = 0): string {
  if (value === undefined) {
    return "";
  }
  return Number(value).toLocaleString("EN", {
    minimumFractionDigits: digits,
  });
}

export function getCurrencySymbol(currencyCode: string, locale = "en-US") {
  const formatted = new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currencyCode,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(0);

  return formatted.replace(/0/g, "").trim();
}

export function getDateFormatByTimeUnit(timeUnit: TimeUnit) {
  switch (timeUnit) {
    case "HOUR": {
      return "hh:mm";
    }
    case "DAY": {
      return "d MMM";
    }
    case "MONTH": {
      return "MMM yyyy";
    }
    case "YEAR": {
      return "yyyy";
    }
  }
}
